export const getSaudeIcon = (saude?: string | null): string => {
	if (!saude) return "text-muted";
	if (saude.toLowerCase().includes("good") || saude.toLowerCase().includes("bom")) return "text-success";
	if (saude.toLowerCase().includes("bad") || saude.toLowerCase().includes("ruim")) return "text-danger pulse-lg";
	if (saude.toLowerCase().includes("regular") || saude.toLowerCase().includes("médio")) return "text-warning pulse-md";
	return "text-muted";
};

export const getSaudeDescricao = (saude?: string | null): string => {
	if (!saude) return "Sem Status";
	const saudeLower = saude.toLowerCase();
	if (saudeLower.includes("good") || saudeLower.includes("bom")) return "Bom";
	if (saudeLower.includes("bad") || saudeLower.includes("ruim")) return "Ruim";
	if (saudeLower.includes("regular") || saudeLower.includes("médio")) return "Regular";
	return "Sem Status";
};

export const getSaudeOrdem = (saude?: string | null): number => {
	const ordemSaude: { [key: string]: number } = {
		Bad: 1,
		Regular: 2,
		Good: 3,
		None: 4,
	};
	return ordemSaude[saude || "None"] || 5;
};

export function ordenarPorSaude<T extends { saude?: string | null }>(items: readonly T[]): T[] {
	return [...items].sort((a, b) => {
		return getSaudeOrdem(a.saude) - getSaudeOrdem(b.saude);
	});
}
